import { ThemeType } from 'grommet';

export const theme: ThemeType = {
  global: {
    colors: {
      brand: '#228BE6',
      'background-back': '#333333',
    },
    font: {
      family: 'Roboto',
      size: '18px',
      height: '20px',
    },
  },
  anchor: {
    textDecoration: 'underline 2px',
    hover: {
      textDecoration: 'underline 2px',
    },
  },
};
